/* @flow */

import _ from 'lodash';

export const getChallengesByIntelligence = ({ challenges }, intelligence_id, language) => 
(_.get(challenges, [intelligence_id, language], []) //.filter((v)=>v.visible)

);
 